import { css } from "@emotion/react"

import Button from "../html/Button"
import Image from "../html/Image"

type Props = {
  hoverClassName?: string
  src: string
  hoverSrc?: string
  alt: string
  width?: number
  height?: number
} & JSX.IntrinsicElements["button"]

const ImageButton = ({ className, src, hoverSrc, alt, width, height, ...props }: Props) => {
  return (
    <Button
      {...props}
      css={css(style)}
      className={className}
      render={({ isHovered }) => <Image src={(isHovered && hoverSrc) || src} alt={alt} width={width} height={height} />}
    />
  )
}

export default ImageButton

const style = css`
  background-color: transparent;
  border: none;
`
